var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-wrapper"},[_c('embed',{attrs:{"width":"100%","height":"100%","src":'/static/file/'+_vm.pdfSrc,"type":"application/pdf"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }